import { Bank, Handshake, MoneyBag, Proyector, Wallet } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'
import type { SidebarManifest } from 'modules/core/lib/manifests/types'

export const sidebarManifest: SidebarManifest = (navigation) => {
  return [
    // Personal group
    {
      identifier: 'my_spending',
      name: i18n.t('sidebar.my_purchases'),
      path: navigation.mySpending.fullPath(),
      factorialOneIcon: Wallet,
      group: 'personal',
      module: 'my_spending',
      priority: 'medium',
    },
    // Finance group
    {
      identifier: 'finance-workspace',
      name: i18n.t('sidebar.finance_workspace'),
      factorialOneIcon: Proyector,
      path: navigation.finance.financialWorkspace.fullPath(),
      group: 'finance',
      module: 'finance_workspace',
      priority: 'high',
    },
    {
      identifier: 'finance-sales',
      name: i18n.t('sidebar.finance_sales'),
      factorialOneIcon: Handshake,
      path: navigation.finance.sales.fullPath(),
      group: 'finance',
      module: 'finance_sales',
      priority: 'medium',
    },
    {
      identifier: 'finance-spending',
      name: i18n.t('sidebar.finance_spending'),
      factorialOneIcon: Wallet,
      path: navigation.finance.spending.fullPath(),
      group: 'finance',
      module: 'finance_spending',
      priority: 'medium',
    },
    {
      identifier: 'finance-treasury',
      name: i18n.t('sidebar.finance_treasury'),
      factorialOneIcon: Bank,
      path: navigation.finance.treasury.fullPath(),
      group: 'finance',
      module: 'finance_treasury',
      priority: 'medium',
    },
    {
      identifier: 'finance-accounting',
      name: i18n.t('sidebar.finance_accounting'),
      factorialOneIcon: MoneyBag,
      path: navigation.finance.accounting.fullPath(),
      group: 'finance',
      module: 'finance_accounting',
      priority: 'lowest',
    },
  ]
}
